import { z } from 'zod';

export const ConfidenceLevelSchema = z.enum([
  'HIGHEST',
  'HIGH',
  'MEDIUM',
  'LOW',
  'LOWEST',
]);

export type ConfidenceLevelType = z.infer<typeof ConfidenceLevelSchema>;
